/* RPS size guide modal.
   Puts a "Size guide" link on the Size row of the variant picker and opens the
   existing size-guide accordion content in a modal. The content is cloned from
   the DOM at open time, so the measurements live in exactly one place
   (sections/rps-product-details.liquid) and can never drift.

   The variant picker is re-rendered by Dawn on every variant change, which
   wipes the injected link, so injection is idempotent and re-runs on mutation. */
(function () {
  if (window.__rpsSizeGuide) return;
  window.__rpsSizeGuide = true;

  var modal = null;
  var lastTrigger = null;

  function sourcePanel() {
    var summaries = document.querySelectorAll('.rps-pd summary, .rps-pd__acc summary, details summary');
    for (var i = 0; i < summaries.length; i++) {
      if (/size\s*guide/i.test(summaries[i].textContent || '')) {
        var d = summaries[i].closest('details');
        if (d) return d.querySelector('.rps-pd__body') || d;
      }
    }
    return null;
  }

  function buildModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'RPSSizeGuide';
    modal.className = 'rps'; // the size-guide styles are scoped under .rps
    modal.setAttribute('hidden', '');
    modal.innerHTML =
      '<div class="rps-sg__overlay" data-sg-close></div>' +
      '<div class="rps-sg__dialog" role="dialog" aria-modal="true" aria-label="Size guide">' +
      '<div class="rps-sg__head">' +
      '<h2 class="rps-sg__title">Size guide</h2>' +
      '<button type="button" class="rps-sg__close" data-sg-close aria-label="Close size guide">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button></div>' +
      '<div class="rps-sg__body"></div></div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-sg-close]')) close();
    });

    return modal;
  }

  function open(trigger) {
    var panel = sourcePanel();
    var m = buildModal();
    if (panel) {
      var body = m.querySelector('.rps-sg__body');
      body.innerHTML = '';
      body.appendChild(panel.cloneNode(true));
    } else if (!m.querySelector('.rps-sg__body').innerHTML) {
      return; // nothing to show
    }
    lastTrigger = trigger || null;
    m.removeAttribute('hidden');
    m.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    var closeBtn = m.querySelector('.rps-sg__close');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('hidden', '');
    document.body.classList.remove('overflow-hidden');
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    lastTrigger = null;
  }

  function sizeLegend() {
    var legends = document.querySelectorAll('fieldset.product-form__input legend, .product-form__input legend');
    for (var i = 0; i < legends.length; i++) {
      if (/^\s*size\b/i.test(legends[i].textContent || '')) return legends[i];
    }
    return null;
  }

  function ensureLink() {
    if (!sourcePanel()) return; // no size guide on this product, no link
    var legend = sizeLegend();
    if (!legend || legend.querySelector('.rps-sg-link')) return;

    var link = document.createElement('button');
    link.type = 'button';
    link.className = 'rps-sg-link';
    link.textContent = 'Size guide';
    link.setAttribute('aria-haspopup', 'dialog');
    link.addEventListener('click', function (event) {
      event.preventDefault();
      open(link);
    });

    legend.classList.add('rps-has-sg');
    legend.appendChild(link);
  }

  var pending = null;
  function ensureSoon() {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      ensureLink();
    }, 60);
  }

  function init() {
    ensureLink();

    // Dawn re-renders the variant picker on every variant change.
    if (window.MutationObserver) {
      var root = document.querySelector('main') || document.body;
      new MutationObserver(ensureSoon).observe(root, { childList: true, subtree: true });
    }

    document.addEventListener('keyup', function (event) {
      if (event.code === 'Escape' || event.key === 'Escape') close();
    });

    // Adding to cart opens the cart drawer; don't leave this stacked underneath.
    document.addEventListener(
      'click',
      function (event) {
        if (event.target.closest && event.target.closest('[name="add"], .product-form__submit')) close();
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
